import axios, { type AxiosError, type CreateAxiosDefaults } from 'axios';
import { toast } from 'react-toastify';

import { ToastNotification } from '@/components';

export function createApiClient(serviceConfig: CreateAxiosDefaults) {
  const apiClient = axios.create({
    ...serviceConfig,
    headers: {
      'Content-Type': 'application/json',
      ...serviceConfig.headers,
    },
  });

  apiClient.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
      if (error.response) {
        const { status, data, headers } = error.response;
        const paywallUrl = (headers['x-paywall-url'] as string) ?? (headers['X-Paywall-Url'] as string);

        switch (status) {
          case 401:
            toast(<ToastNotification type="error" title="Unauthorized! Redirecting to login..." />);
            window.location.reload();
            break;
          case 403:
            if (paywallUrl) {
              window.location.href = paywallUrl;
              return;
            }
            break;
          case 500:
            toast(<ToastNotification type="error" title="Internal Server Error!" />);
            break;
          default:
            toast(<ToastNotification type="error" title="Unexpected error" />);
            console.error('Unexpected error:', data);
        }
      }

      return Promise.reject(error);
    },
  );

  return apiClient;
}
